import { useState } from 'react';

import { Role } from '@Root/src/api-generated';

import { useGlobalContext } from '@Components/context/GlobalContext';

declare global {
  interface Window {
    setWpm: (wpm: number) => void;
    setDuration: (duration: number) => void;
  }
}

export const useTypingCheats = () => {
  const { user } = useGlobalContext();

  const [wpm, setWpm] = useState<number | undefined>(undefined);
  const [durationInSeconds, setDurationInSeconds] = useState<number | undefined>(undefined);

  if (isAllowedToCheat(user?.roles) && typeof window !== 'undefined') {
    window.setWpm = (wpm) => setWpm(wpm);
    window.setDuration = (duration) => setDurationInSeconds(duration);
  }

  return { wpm, durationInSeconds };
};

const isAllowedToCheat = (roles?: Role[]) => {
  // todo: could be a problem if auth token in local storage was edited?
  if (roles && roles.includes(Role.ROLE_ADMIN)) {
    return true;
  }

  // todo: test this before launch!
  // Cheats should never be available in the production environment, but at most for administrators
  return process.env.NEXT_PUBLIC_APP_ENV !== 'prod';
};
